
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PhoneNumberInputProps {
  phoneNumber: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PhoneNumberInput = ({ phoneNumber, onChange }: PhoneNumberInputProps) => {
  // Format the phone number for display (optional)
  const formatPhoneNumber = (value: string) => {
    if (!value) return "";
    
    const phoneNumber = value.replace(/\D/g, "");
    const phoneNumberLength = phoneNumber.length;
    
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Strip all non-digits before sending to parent
    const input = e.target.value.replace(/\D/g, "");
    
    // Create a new event object with the modified value
    const newEvent = {
      ...e,
      target: {
        ...e.target,
        value: input
      }
    };
    
    onChange(newEvent);
  };

  return (
    <div>
      <Label htmlFor="phone" className="text-black">Phone Number</Label>
      <div className="relative">
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
          +1
        </div>
        <Input
          id="phone"
          value={formatPhoneNumber(phoneNumber)}
          onChange={handleInputChange}
          placeholder="000-000-0000"
          className="pl-8 bg-white text-black"
          maxLength={12} // Account for formatting characters
        />
      </div>
    </div>
  );
};
